import { AgGridTable, type CustomColDef } from '@shared/components/ui/AgGridTable';
import type { Topup } from '../../models';

interface TopupsAgGridTableProps {
    topups: Topup[];
    columnDefs: CustomColDef[];
}

export const TopupsAgGridTable = ({
    topups,
    columnDefs,
}: TopupsAgGridTableProps) => {
    return (
        <AgGridTable
            data={topups}
            columnDefs={columnDefs}
            height="calc(100vh - 150px)"
            rowHeight={64}
            enableSelection={false}
            suppressAggFuncInHeader={true}
        />
    );
};

